import React, { useState, useReducer } from "react"
import styles from "./contactForm.module.scss"
import { SeeMoreButton } from "../seeMoreButton/seeMoreButton"
import Loader from "react-loader-spinner"
import tt from "../../helpers/translation"
import Slide from "react-reveal/Slide"
import { Link } from "gatsby"

const initialState = {
  name: null,
  lastname: null,
  email: null,
  message: null,
  acceptedPolicy: false,
  formResult: null,
  loading: false,
}

function reducer(state, action) {
  switch (action.type) {
    case "SET_FORM_VALUE":
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      }
    case "SEND_FORM":
      return {
        ...state,
        loading: true,
        formResult: null,
      }
    case "SEND_FORM_OK":
      return {
        ...initialState,
        formResult: action.payload,
      }
    case "SEND_FORM_FAILED":
      return {
        ...state,
        loading: false,
        formResult: action.payload,
      }
  }
}

const ContactForm = ({ pageContext, lang }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const [acceptedPolicy, setPolicy] = useState(false)
  const disabled =
    state &&
    !(
      state.name &&
      state.lastname &&
      state.email &&
      state.message &&
      acceptedPolicy
    )

  const [resultUrls] = pageContext.urls.filter(obj => {
    return obj.id === "LEGAL"
  })

  const onInputChange = e => {
    e.preventDefault()
    dispatch({
      type: "SET_FORM_VALUE",
      payload: { field: e.target.name, value: e.target.value },
    })
  }

  const onSubmit = e => {
    e.preventDefault()
    dispatch({ type: "SEND_FORM" })
    fetch(`${process.env.GATSBY_FORM_ENDPOINT}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        origin: "contact-form",
        name: state.name,
        lastName: state.lastname,
        email: state.email,
        message: state.message,
      }),
    })
      .then(res => {
        if (res.status !== 200) {
          throw new Error("FORM_FAILED")
        }
        dispatch({
          type: "SEND_FORM_OK",
          payload: {
            message: tt(
              "Thank you for contacting us, we will be in touch soon!",
              lang
            ),
            type: "success",
          },
        })
      })
      .catch(err => {
        dispatch({
          type: "SEND_FORM_FAILED",
          payload: {
            message: tt(
              "There was an error submitting your form, please try again later",
              lang
            ),
            type: "error",
          },
        })
      })
  }

  return (
    <div className={`${styles.blue_section_container}`}>
      <Slide left>
        <div className={styles.text_container}>
          <h2>{tt("Contact us", lang)}</h2>
          <form className={styles.form_container} onSubmit={e => onSubmit(e)}>
            <div className={styles.input_container}>
              <p>{tt("Name:", lang)}</p>
              <input name="name" onChange={onInputChange} />
            </div>
            <div className={styles.input_container}>
              <p>{tt("Last Name:", lang)}</p>
              <input name="lastname" onChange={onInputChange} />
            </div>
            <div className={styles.input_container}>
              <p>{tt("Email:", lang)}</p>
              <input name="email" type="email" onChange={onInputChange} />
            </div>
            <div className={styles.input_container}>
              <p>{tt("Message:", lang)}</p>
              <textarea
                name="message"
                id="message"
                rows="6"
                onChange={onInputChange}
              />
            </div>
            <div className={styles.privacy_policy}>
              <input
                id="privacy-policy"
                onChange={() => setPolicy(!acceptedPolicy)}
                type="checkbox"
              />
              <label htmlFor="privacy-policy">
                {tt("I have read and accepted the ", lang)}
                <Link to={resultUrls[`url_${lang}`]}>
                  {tt("privacy and data protection policy.", lang)}
                </Link>
              </label>
            </div>
            <div style={{ marginTop: "15px" }}>
              <SeeMoreButton
                text={tt("Send Form", lang)}
                type="submit"
                disabled={disabled}
                disabledLight={true}
                contrast={true}
              />
            </div>
            <div className={styles.validated}>
              {disabled ? null : state.loading ? (
                <Loader
                  className={styles.loader}
                  type="ThreeDots"
                  color="#1e3765"
                  height={20}
                  width={50}
                />
              ) : null}
              {state.formResult && (
                <p
                  className={
                    state.formResult.type === "error"
                      ? styles.form_result_fail
                      : styles.form_result_success
                  }
                >
                  {state.formResult.message}
                </p>
              )}
            </div>
          </form>
        </div>
      </Slide>
    </div>
  )
}

export default ContactForm
